export default "__VITE_ASSET__DYd02$eu__"